(function () {
  const selector = '[data-scroll-up-reveal]';
  const scrollTriggeredSelector = '[data-scroll-up-reveal-on-scroll]';
  const visibleClass = 'scroll-up-reveal--visible';
  const readyAttr = 'scrollUpRevealReady';
  const scrollTriggeredReadyAttr = 'scrollUpRevealOnScrollReady';
  const pendingScrollTriggeredReveals = new Set();
  let hasScrolled = window.scrollY > 0;

  function reveal(element) {
    pendingScrollTriggeredReveals.delete(element);
    element.classList.add(visibleClass);
  }

  function getRevealElements(root, targetSelector) {
    const elements = [];

    if (root instanceof Element && root.matches(targetSelector)) {
      elements.push(root);
    }

    elements.push(...root.querySelectorAll(targetSelector));

    return elements;
  }

  function initScrollUpReveal(root = document) {
    const elements = getRevealElements(root, selector).filter((element) => {
      return !element.dataset[readyAttr];
    });

    if (elements.length === 0) {
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset[readyAttr] = 'true';
        reveal(element);
      });
      return;
    }

    if (!window.scrollUpRevealObserver) {
      window.scrollUpRevealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          reveal(entry.target);
          window.scrollUpRevealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12
      });
    }

    elements.forEach((element) => {
      element.dataset[readyAttr] = 'true';
      window.scrollUpRevealObserver.observe(element);
    });
  }

  function initScrollTriggeredReveal(root = document) {
    const elements = getRevealElements(root, scrollTriggeredSelector).filter((element) => {
      return !element.dataset[scrollTriggeredReadyAttr];
    });

    if (elements.length === 0) {
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset[scrollTriggeredReadyAttr] = 'true';
        reveal(element);
      });
      return;
    }

    if (!window.scrollTriggeredRevealObserver) {
      window.scrollTriggeredRevealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          if (hasScrolled) {
            reveal(entry.target);
          } else {
            pendingScrollTriggeredReveals.add(entry.target);
          }

          window.scrollTriggeredRevealObserver.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.12
      });
    }

    elements.forEach((element) => {
      element.dataset[scrollTriggeredReadyAttr] = 'true';
      window.scrollTriggeredRevealObserver.observe(element);
    });
  }

  window.addEventListener('scroll', () => {
    hasScrolled = true;
    pendingScrollTriggeredReveals.forEach((element) => reveal(element));
  }, { passive: true });

  function init(root = document) {
    initScrollUpReveal(root);
    initScrollTriggeredReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
